module.exports = __webpack_public_path__ + "fonts/SuisseIntl-SemiBoldItalic.3eebe9b.woff";